import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFindings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M9.077 4.963c.808-1.4 2.829-1.4 3.637 0l5.456 9.45c.808 1.4-.202 3.15-1.819 3.15H5.44c-1.617 0-2.627-1.75-1.82-3.15zm1.819 2.195c.434 0 .787.353.787.788v3.542a.788.788 0 0 1-1.575 0V7.946c0-.435.353-.788.787-.788m0 7.697a.788.788 0 1 0 0-1.575.788.788 0 0 0 0 1.575"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFindings;
